// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__39zfT","col":"CardReaderDesc_col__sSm5E","label":"CardReaderDesc_label__1B3w4"};